module.exports = __webpack_public_path__ + "img/plane.a4c9b900.png";